import React from 'react';
import { Input, Button, IconFont } from '@jd/find-react';
import { PlusOutlined } from '@ant-design/icons';
import { get, set, cloneDeep } from 'lodash';
import styles from './FsRemovals.module.less';
import KeeVue from '../base/KeeVue.js'

export default class FsRemovals extends KeeVue {
  constructor(props) {
    super(props);
    this.state = {
      path: [0, 0, 0],
      randId: this.getRandString()
    };
  }

  componentWillMount() {
		this.registComponent();
	}

  getPath = (fpath) => {
    if (fpath.length === 1) {
      return null;
    }
    return fpath.slice(0, fpath.length - 1).map(item => `${item}.children`).join('.');

    /**
     * 0 0
     * 1 0.children
     * 2 children.0.children.0.children
     * 3
     */
  };

  CanBeInput = ({
    content, onChange, onDelete, onSelect, isActive
  }) => (<div
        className={isActive ? styles.optIdx : styles.optText}
        onClick={() => {
          // setIsEdit(true);
          onSelect();
        }}
    >
      <Input
        className={styles.modifyValue}
        value={content}
        onChange={({ target }) => {
          onChange(target.value);
        }}
      ></Input>
      {isActive ? <IconFont
        className={styles.close}
        type="iconCloseCircle-Filled"
        style={{ color: 'rgba(48,111,220,1)', fontSize: '16px' }}
        onClick={(e) => {
          onDelete();
          // eslint-disable-next-line no-unused-expressions
          e.stopPropagation;
        }}
      /> : ''}
    </div>
    );

  // 列表视图
  View = ({
    value, list, onChange, onSelect, path: dPath
  }) => {
    const add = () => {
      list.push({ label: '', value: '' });
      onChange && onChange(list);
      this.refresh();
    };

    const remove = (index) => {
      list.splice(index, 1);
      onChange && onChange(list);
      this.refresh();
    };

    const edit = (index, endValue) => {
      // eslint-disable-next-line no-param-reassign
      list[index].label = endValue;
      list[index].value = endValue;
      onChange && onChange(list);
      this.refresh();
    };
    const { CanBeInput } = this;

    return <div className={styles.cascaList}>
      <p className={styles.title}>{value}</p>
      {
          list && list.map((item, index) => <div className={styles.otpList} key={index}>
            <CanBeInput
              content={item.value}
              onChange={(content) => {
                edit(index, content);
              }}
              onDelete={() => {
                remove(index);
              }}
              isActive={dPath === index}
              onSelect={() => { onSelect(index); }}
            />
          </div>)
      }
      <Button
        type="text"
        icon={<PlusOutlined />}
        onClick={() => {
          add();
        }}
      >
        添加
      </Button>
    </div>;
  };

  getActieData = (dpath, datac) => {
    const clonePath = this.getPath(dpath);
    if (!clonePath) {
      return datac;
    }
    return get(datac, clonePath) || [];
  };

  setActieData = (dpath, oldData, nList) => {
    const clonePath = this.getPath(dpath);
    if (!clonePath) {
      // setData([...nList]);
      // this.setState({ data: [...nList] });
    this.props.component.cp.listOptions = [...nList]
      return;
    }
    set(oldData, clonePath, nList);
    // setData(cloneDeep(oldData));
    // this.setState({ data: cloneDeep(oldData) });
    this.props.component.cp.listOptions = cloneDeep(oldData)
  };

  render() {
    const { View } = this;
    const { listOptions } = this.props.component.cp;
    const {
      path
    } = this.state;
    return <div className={styles.cascaBox}>
      {
      path.map((item, index) => {
        const Path = path.slice(0, index + 1);
        return <View
          value={`${index + 1}级选项`}
          key={index}
          list={this.getActieData(Path, listOptions)}
          onChange={(list) => {
            this.setActieData(Path, listOptions, list);
          }}
          path={item}
          onSelect={(e) => {
            const oldPath = [...path];
            oldPath[index] = e;
            this.setState({ path: oldPath });
          }}
          {...this.props.component.extProps}
        ></View>;
      })
    }
    </div>;
  }
}
